import React from 'react';
import { DollarSignIcon } from 'lucide-react';
export function FreeCourseNotice() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1252">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1253">
        <div className="flex items-start gap-4 p-5 rounded-xl mb-12 border-2" style={{
        backgroundColor: '#f0f7f3',
        borderColor: '#1e3d2f'
      }} data-id="element-1254">
          <DollarSignIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#1e3d2f'
        }} data-id="element-1255" />
          <p className="text-base font-semibold" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1256">
            This course is <strong data-id="element-1257">free of charge</strong> and is open to the
            general public as well as FLSC club members.
          </p>
        </div>
      </div>
    </div>;
}